import type { ReactNode } from "react";
import { useEffect } from "react";
import { useCurrentUserQuery, useUserStore } from "@/entities/user";
import { setOnUnauthorizedCallback } from "@/shared/api";

export interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  useCurrentUserQuery();
  const clearUser = useUserStore((s) => s.clearUser);

  useEffect(() => {
    // Если любой запрос в приложении завершился с 401, сбрасываем авторизацию
    setOnUnauthorizedCallback(() => {
      clearUser();
    });

    return () => {
      setOnUnauthorizedCallback(null);
    };
  }, [clearUser]);

  return <>{children}</>;
};
